// modalManager keeps track of which modal is opened
// so only one modal is opened at a time
// used with nav and searchModal

//   modalManager.add({
//     key: 'nav',
//     open: () => instance.open(),
//     open: () => instance.close(),
//  })

//  modalManager.open('nav')

const modals = {};
let openModal = null;

const modalManager = {
  /**
   * @param {Object} modal
   *   @param {String} key
   *   @param {Function} open
   *   @param {Function} close
   */
  add( modal ) {
    modals[modal.key] = modal;
  },

  open(key) {
    const modal = modals[key];
    const isOpenModal = modal === openModal;
    if (!modal || isOpenModal) return;

    if (openModal) openModal.close();
    modal.open();
    openModal = modal;
  },

  close(key) {
    const modal = modals[key];
    const isOpenModal = modal === openModal;
    if (!modal) return;

    modal.close();
    if (isOpenModal) openModal = null;
  },

  toggle(key) {
    const modal = modals[key];
    const isOpenModal = modal === openModal;
    if (!modal) return;

    if (isOpenModal) {
      modalManager.close(key);
    } else {
      modalManager.open(key);
    }
  },
};

export default modalManager;
window.modalManager = modalManager;
